import React, { useState } from 'react'
import './titleDueDateEditor.css'
import { STATUS_OPTION } from '../../constants';

//own component just for simplicity of edit extension
//new Date('03/10/00') make sure valide date and is a duedate in the future.

const AddEditor = ({ selectedTodoReal, titleNew, updateTodo, date, setFontColor, todo, savedTitle, savedDueDate, setFontSize, ...props }) => {
  const [chosenEmoji, setChosenEmoji] = useState(null);
  const [open, setOpen] = useState(null)

  return (
    <React.Fragment key={selectedTodoReal.rowID}>
      <div className="forceCol" style={{ placeItems: "center", placeContent: "center", boxShadow: "none", border: "none", marginTop: 0 }}>
        <div style={{ display: "flex", flexDirection: "column" }} >
          <div className="ee-points-row">
            <label className="ee-points-label" htmlFor="points-input">Points:</label>
            <input
              id="points-input"
              className="ee-points-input"
              onChange={e => { updateTodo("points", e.target.value) }}
              value={(selectedTodoReal && selectedTodoReal.points) ? selectedTodoReal.points : 1}
              type="number"
              min={0}
            />
          </div>
          <div className="ee-points-row">
            <label className="ee-points-label" htmlFor="weekpoints-input">Week Points:</label>
            <input
              id="weekpoints-input"
              className="ee-points-input"
              onChange={e => { updateTodo("weekPoints", e.target.value) }}
              value={(selectedTodoReal && selectedTodoReal.weekPoints) ? selectedTodoReal.weekPoints : 1}
              type="number"
              min={0}
            />
          </div>
        </div>
        <div className="ee-status-section">
          <div
            className="ee-status-title"
            style={{
              backgroundColor: selectedTodoReal.status,
              color: selectedTodoReal.status && ["#fff", "white", "#ffffff", "rgb(255,255,255)"].includes(selectedTodoReal.status.toLowerCase()) ? "#222" : "#fff"
            }}
          >
            Status:
          </div>
          <div className="ee-status-circles-row">
            {Object.values(STATUS_OPTION).map(status => (
              <div key={status} className="ee-status-circle" style={{ backgroundColor: status }} onClick={() => updateTodo("status", status)} />
            ))}
          </div>
          <div
            className="ee-status-title"
            style={{
              backgroundColor: selectedTodoReal.actionStatus,
              color: selectedTodoReal.actionStatus && ["#fff", "white", "#ffffff", "rgb(255,255,255)"].includes(selectedTodoReal.actionStatus.toLowerCase()) ? "#222" : "#fff"
            }}
          >
            Action Status:
          </div>
          <div className="ee-status-circles-row">
            {Object.values(STATUS_OPTION).map(status => (
              <div key={status} className="ee-status-circle" style={{ backgroundColor: status }} onClick={() => updateTodo("actionStatus", status)} />
            ))}
          </div>
          <div
            className="ee-status-title"
            style={{
              backgroundColor: selectedTodoReal.weekActionStatus,
              color: selectedTodoReal.weekActionStatus && ["#fff", "white", "#ffffff", "rgb(255,255,255)"].includes(selectedTodoReal.weekActionStatus.toLowerCase()) ? "#222" : "#fff"
            }}
          >
            Week Action Status:
          </div>
          <div className="ee-status-circles-row">
            {Object.values(STATUS_OPTION).map(status => (
              <div key={status} className="ee-status-circle" style={{ backgroundColor: status }} onClick={() => updateTodo("weekActionStatus", status)} />
            ))}
          </div>
          <div
            className="ee-status-title"
            style={{
              backgroundColor: selectedTodoReal.weekActionStatus,
              color: selectedTodoReal.weekActionStatus && ["#fff", "white", "#ffffff", "rgb(255,255,255)"].includes(selectedTodoReal.weekActionStatus.toLowerCase()) ? "#222" : "#fff"
            }}
          >
            Difficulty:
          </div>
          <div className="ee-status-circles-row">
            {Object.values(STATUS_OPTION).map(difficulty => (
              <div key={difficulty} className="ee-status-circle" style={{ backgroundColor: difficulty }} onClick={() => updateTodo("difficulty", difficulty)} />
            ))}
          </div>
        </div>

      </div>
    </React.Fragment>
  )
}


export default AddEditor;




//<div className="forceRow"  style={{marginTop:"20px", display: "flex", placeContent: "center"}} >
{/* <TextField
key={todo.id}
defaultValue={todo.fontSize}
style={{width: "50px"}}
onChange={e => setFontSize(`${e.target.value}%`)}        
label={`${todo.fontSize ? parseInt(todo.fontSize.split("%")[0]) : "0"}`}
type="number"
value={chosenEmoji && chosenEmoji.emoji}
/> */}
{/* <FormControlLabel control={
<Checkbox
  value="checkedB"
  color="primary"
/>
}
label="bold"
/> */}